import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../contexts/DataContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import TeamModal from './TeamModal';

const { FiUserPlus, FiMail, FiTrash2, FiEdit2, FiUser } = FiIcons;

const Team = () => {
  const { team, deleteTeamMember } = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingMember, setEditingMember] = useState(null);

  const handleEdit = (member) => {
    setEditingMember(member);
    setIsModalOpen(true);
  };

  const handleAddNew = () => {
    setEditingMember(null);
    setIsModalOpen(true);
  };

  return (
    <div className="space-y-8">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-4xl font-black text-slate-900 tracking-tighter">My Team</h1>
          <p className="text-slate-400 font-medium">Manage your organization's staff and access.</p>
        </div>
        <button onClick={handleAddNew} className="bg-blue-600 text-white px-8 py-4 rounded-3xl font-black shadow-xl shadow-blue-100 flex items-center gap-3 hover:bg-blue-700 transition-all">
          <SafeIcon icon={FiUserPlus} /> Add Member
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {team.map(member => (
          <div key={member.id} className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm hover:shadow-xl transition-all group">
            <div className="flex justify-between items-start mb-6">
              <img src={member.avatar || 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop'} className="w-16 h-16 rounded-2xl object-cover border-2 border-white shadow-md" />
              <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => handleEdit(member)} className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all">
                  <SafeIcon icon={FiEdit2} />
                </button>
                <button onClick={() => deleteTeamMember(member.id)} className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all">
                  <SafeIcon icon={FiTrash2} />
                </button>
              </div>
            </div>
            <h3 className="font-black text-slate-900 text-lg mb-1">{member.name}</h3>
            <span className="bg-blue-50 text-blue-600 px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest">{member.role}</span>
            <div className="mt-6 flex items-center gap-3 text-xs text-slate-400 font-bold">
              <SafeIcon icon={FiMail} className="text-blue-500" /> {member.email}
            </div>
          </div>
        ))}
        {team.length === 0 && (
          <div className="col-span-full py-24 text-center bg-white rounded-[3rem] border-2 border-dashed border-slate-100">
            <SafeIcon icon={FiUser} className="text-6xl text-slate-100 mx-auto mb-4" />
            <p className="text-slate-400 font-bold">No team members yet.</p>
          </div>
        )}
      </div>

      <TeamModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} member={editingMember} />
    </div>
  );
};

export default Team;